(() => {
  'use strict';

  const number = new Intl.NumberFormat(window.ZinVoltI18n.locale, { maximumFractionDigits: 1 });
  const configurations = {
    4: '1 × Core',
    8: '1 × Core + 1 × Link',
    12: '1 × Core + 2 × Link',
    16: '1 × Core + 3 × Link'
  };

  const parseValue = (field) => {
    if (!field || field.value.trim() === '') return null;
    const value = Number(String(field.value).replace(',', '.'));
    return Number.isFinite(value) ? value : null;
  };

  const chooseCapacity = (dailyShift) => {
    if (dailyShift < 8) return 4;
    if (dailyShift < 12) return 8;
    if (dailyShift < 16) return 12;
    return 16;
  };

  const initialise = (root) => {
    if (root.dataset.zvCoreChoiceReady === 'true') return;
    root.dataset.zvCoreChoiceReady = 'true';

    const form = root.querySelector('[data-zv-core-choice-form]');
    const error = root.querySelector('[data-zv-core-choice-error]');
    const placeholder = root.querySelector('[data-zv-core-choice-placeholder]');
    const result = root.querySelector('[data-zv-core-choice-result]');
    if (!form || !error || !result) return;

    form.addEventListener('submit', (event) => {
      event.preventDefault();
      error.hidden = true;
      error.textContent = '';

      const annualImport = parseValue(form.elements.annualImport);
      const annualExport = parseValue(form.elements.annualExport);
      const annualGeneration = parseValue(form.elements.annualGeneration);
      const futurePlans = Array.from(form.querySelectorAll('input[name="futurePlans"]:checked'));

      if (annualImport === null || annualExport === null || annualImport < 0 || annualExport < 0) {
        error.textContent = window.ZinVoltI18n.t("enter_valid_annual_grid_import_and_export_6d3f06");
        error.hidden = false;
        error.focus?.();
        return;
      }

      if (annualImport > 50000 || annualExport > 50000 || (annualGeneration !== null && annualGeneration > 50000)) {
        error.textContent = window.ZinVoltI18n.t("check_your_annual_figures_the_maximum_input_59df7f");
        error.hidden = false;
        return;
      }

      if (annualGeneration !== null && annualExport > annualGeneration) {
        error.textContent = window.ZinVoltI18n.t("your_grid_export_cannot_exceed_your_total_8b7cca");
        error.hidden = false;
        return;
      }

      const dailyShift = Math.min(annualImport, annualExport) / 365;
      const hasShiftableEnergy = annualImport > 0 && annualExport > 0;
      const capacity = chooseCapacity(dailyShift);
      const title = root.querySelector('[data-zv-core-choice-result-title]');
      const copy = root.querySelector('[data-zv-core-choice-result-copy]');
      const capacityNode = root.querySelector('[data-zv-core-choice-capacity]');
      const configuration = root.querySelector('[data-zv-core-choice-configuration]');
      const daily = root.querySelector('[data-zv-core-choice-daily]');
      const notice = root.querySelector('[data-zv-core-choice-notice]');
      const eyebrow = root.querySelector('[data-zv-core-choice-result-eyebrow]');

      if (placeholder) placeholder.hidden = true;
      result.hidden = false;

      if (!hasShiftableEnergy) {
        eyebrow.textContent = window.ZinVoltI18n.t("individual_review_needed_6e3208");
        capacityNode.innerHTML = '—';
        title.textContent = window.ZinVoltI18n.t("a_reliable_automatic_capacity_recommendation_is_not_44fa05");
        copy.textContent = window.ZinVoltI18n.t("without_both_grid_export_and_later_grid_53b9dc");
        configuration.textContent = window.ZinVoltI18n.t("not_determined_automatically_d846e3");
        daily.textContent = window.ZinVoltI18n.t("insufficient_annual_figures_for_shifting_energy_use_e1c62b");
        notice.textContent = window.ZinVoltI18n.t("the_core_may_also_suit_other_energy_21ad0d");
        result.focus({ preventScroll: true });
        result.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }

      eyebrow.textContent = dailyShift < 4 ? window.ZinVoltI18n.t("cautious_starting_configuration_95c34d") : window.ZinVoltI18n.t("initial_core_estimate_f6c703");
      capacityNode.innerHTML = `${capacity} <span>kWh</span>`;
      title.textContent = `ZinVolt Core ${capacity} kWh`;
      configuration.textContent = configurations[capacity];
      daily.textContent = window.ZinVoltI18n.t("amount_kwh_per_calendar_day_de13e8", {amount:number.format(dailyShift)});

      if (dailyShift < 4) {
        copy.textContent = window.ZinVoltI18n.t("the_calculated_average_amount_of_energy_available_23b5c4");
      } else if (capacity === 16) {
        copy.textContent = window.ZinVoltI18n.t("your_annual_figures_suggest_a_large_average_869bc2");
      } else {
        copy.textContent = window.ZinVoltI18n.t("the_check_selects_the_largest_core_capacity_9997a8");
      }

      const notes = [
        window.ZinVoltI18n.t("this_is_an_initial_estimate_based_on_0bfdab")
      ];
      if (futurePlans.length) {
        notes.push(window.ZinVoltI18n.t("your_future_plans_have_not_been_used_776c52"));
      }
      if (dailyShift >= 16) {
        notes.push(window.ZinVoltI18n.t("more_than_16_kwh_or_multiple_towers_d37e17"));
      }
      notes.push(window.ZinVoltI18n.t("for_more_accurate_advice_we_prefer_to_bcbf21"));
      notice.textContent = notes.join(' ');

      result.focus({ preventScroll: true });
      result.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  };

  const initialiseAll = (scope = document) => {
    scope.querySelectorAll('[data-zv-core-choice]').forEach(initialise);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialiseAll());
  } else {
    initialiseAll();
  }

  document.addEventListener('shopify:section:load', (event) => initialiseAll(event.target));
})();
